export default window.BMT.config;
